import React, { useState } from 'react'
import { Navigate, useNavigate, useParams } from 'react-router'
import { PageHeader } from '@mobi/component-library/Navigation/PageHeader'
import { Tabs as NavTab, TabButton } from '@mobi/component-library/Navigation/Tabs'
import { TabPillButton, TabsPill } from '@mobi/component-library/Navigation/TabsPill'
import { ACCOUNT_ACTIVITY_ROUTE } from '@core/Areas/Account/Pages/Activity/constants'
import { MainContainer } from '@core/Components/Containers'
import { useFeature } from '@core/Utils/hooks/useFeature'
import { MyBetsContent } from './Components/MyBetsContent'
import type { FilterContent, MyBetsTab } from './types'

export const MyBetsPage: React.FC = () => {
  const isUnifiedMyBetsFeatureActive = useFeature('unified-my-bets-racing-sports')
  const [selectedFilter, setSelectedFilter] = useState<FilterContent>('Racing')
  const navigate = useNavigate()
  const { tab: activeTab } = useParams<{ tab: MyBetsTab }>()

  if (!isUnifiedMyBetsFeatureActive) {
    return <Navigate to={`/${ACCOUNT_ACTIVITY_ROUTE}`} replace />
  }

  if (activeTab !== 'pending' && activeTab !== 'results') {
    return <Navigate to='/account/my-bets/pending' replace />
  }

  const handleTabChange = (tab: MyBetsTab): void => {
    navigate(`/account/my-bets/${tab}`)
  }

  return (
    <MainContainer background='surface300'>
      <PageHeader title='My Bets' />

      <NavTab bottomBorder='soft'>
        <TabButton
          content='Pending Bets'
          isSelected={activeTab === 'pending'}
          onClick={() => handleTabChange('pending')}
        />
        <TabButton
          content='Resulted Bets'
          isSelected={activeTab === 'results'}
          onClick={() => handleTabChange('results')}
        />
      </NavTab>

      <TabsPill bottomBorder='hard'>
        <TabPillButton
          content='Racing'
          isSelected={selectedFilter === 'Racing'}
          onClick={() => setSelectedFilter('Racing')}
        />
        <TabPillButton
          content='Sports'
          isSelected={selectedFilter === 'Sports'}
          onClick={() => setSelectedFilter('Sports')}
        />
      </TabsPill>

      <MyBetsContent
        activeTab={activeTab}
        filterContent={selectedFilter}
        setSelectedFilter={setSelectedFilter}
      />
    </MainContainer>
  )
}
